import React, { useContext, useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import { API_HOST } from '../../../consts';
import CardRecursos from './CardRecursos';
import { ThemeContext } from 'styled-components';
import { get } from 'lodash';
import { AcompanharAtividadeIcon, BuscarAtividadeIcon, CriarAtividadeIcon, BuscarItensIcon, CriarItensIcon, AgendarAvaliacaoIcon, GerarPlanoDeRecuperacaoIcon, GerarPlanoDeAulaIcon, AcessoRelatorioIcon, AcessoRelatorioIntegrativosIcon, AcessoRelatorioEngajamentoIcon } from '../../../assets/images/portal/iconsPortal'

const RecursosList = ({ history }) => {
  const theme = useContext(ThemeContext);
  const [metadata, setMetadada] = useState();

  const mapMetadata = (metadata) => {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.requireness;
    });
    return mapped;
  }

  const fetchMetadata = async () => {
    return await axios
      .get(`${API_HOST}/params/param`)
      .then((response) => {
        setMetadada(mapMetadata(response.data))
      });
  }

  const styleGrid = {
    padding: '19px 17px 19px 17px',
    borderRadius: '8px',
    // gap: '17px',
    backgroundColor: `${theme.action}35`
  };

  useEffect(() => {
    fetchMetadata();
  }, []);

  const shouldDisplay = (field) => {
    return get(metadata, field) > 0;
  }

  return (
    <Grid container spacing={2} style={styleGrid}>
      <CardRecursos
        title={'Acompanhar trilhas adaptativas, avaliações e atividades'}
        subtitle={
          'Acesse a lista de trilhas adaptativas, avaliações e atividades aplicadas por você.'
        }
        img={<AcompanharAtividadeIcon theme={theme.primary}/>}
        link={'exams/dashboard'}
      />

      <CardRecursos
        title={'Buscar trilhas adaptativas, avaliações e atividades'}
        subtitle={
          'Acesse a lista de trilhas adaptativas, avaliações e atividades e realize a sua busca.'
        }
        img={<BuscarAtividadeIcon theme={theme.primary}/>}
        link={'/instrumentos-cognitivos/tipo/1?Modal=True'}
      />

      <CardRecursos
        title={'Criar atividades'}
        subtitle={
          'Crie suas atividades, adicionando recursos pedagógicos e itens criados por você ou por outros especialistas.'
        }
        img={<CriarAtividadeIcon theme={theme.primary}/>}
        link={shouldDisplay('avaliacao.exam_type')?'instrumentos-cognitivos/new/dados':'instrumentos-cognitivos/new/dados/tipo/3'}
      />

      <CardRecursos
        title={'Buscar itens e recursos'}
        subtitle={
          'Acesse o banco de itens e recursos pedagógicos e encontre o que você procura.'
        }
        img={<BuscarItensIcon theme={theme.primary}/>}
        link={'/itens/tipo/1?Modal=True'}
      />

      <CardRecursos
        title={'Criar itens e recursos'}
        subtitle={
          'Crie itens e recursos pedagógicos que poderão ser utilizados em suas atividades.'
        }
        img={<CriarItensIcon theme={theme.primary}/>}
        link={'/itens/new/dados/tipo/1'}
      />

      <CardRecursos
        title={'Agendar avaliações em larga escala'}
        subtitle={
          'Faça o agendamento de suas atividades, avaliações e em datas e horários específicos.'
        }
        img={<AgendarAvaliacaoIcon theme={theme.primary}/>}
        link={'https://agendamento-sesi.educat.net.br/'}
      />

      <CardRecursos
        title={'Gerar plano de recuperação pelo assistente professor'}
        subtitle={
          'Acesse a inteligência artificial para a criação de plano de recuperação.'
        }
        img={<GerarPlanoDeRecuperacaoIcon theme={theme.primary}/>}
        link={'/personal-create/5/plano-intervencao'}
      />

      <CardRecursos
        title={'Gerar avaliações pelo assistente do professor'}
        subtitle={
          'Acesse a inteligência artificial para a criação de avaliações.'
        }
        img={<CriarAtividadeIcon theme={theme.primary}/>}
        link={'/personal-create/6/avaliacao/new'}
      />

      <CardRecursos
        title={'Gerar plano de aula pelo assistente professor'}
        subtitle={
          'Acesse a inteligência artificial para a criação planos de aula.'
        }
        img={<GerarPlanoDeAulaIcon theme={theme.primary}/>}
        link={'/personal-create/1/plano-aula'}
      />

      <CardRecursos
        title={'Acessar relatório de avaliações'}
        subtitle={
          'Acesse o relatório de avaliações, identificando as habilidades e competências de seus estudantes.'
        }
        img={<AcessoRelatorioIcon theme={theme.primary}/>}
        link={'/filter-dr'}
      />

      <CardRecursos
        title={'Acessar relatório integrativo de avaliações e atividades'}
        subtitle={
          'Acesse o relatório integrativo e compare os resultados das avaliações realizadas por seus estudantes.'
        }
        img={<AcessoRelatorioIntegrativosIcon theme={theme.primary}/>}
        link={'/filter-relatorio-individual-dn'}
      />

      <CardRecursos
        title={'Acessar relatório de engajamento ao assistente professor'}
        subtitle={
          'Compare o engajamento das regionais, escolas, segmento/etapa, série/ano.'
        }
        img={<AcessoRelatorioEngajamentoIcon theme={theme.primary}/>}
        link={'/report-plan'}
      />
    </Grid>
  );
};

export default RecursosList;
